import { EMPLOYMENT_TYPES, TAX_CLASSIFICATIONS } from 'cpool-constants';
import type { ApplicantCreation } from 'cpool-schemas';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Azubi } from './Azubi';
import { EmployeeWorker } from './EmployeeWorker';
import { Official } from './Official';
import { OtherIncomeOnly } from './OtherIncomeOnly';
import { Pensioner } from './Pensioner';
import { SelfEmployed } from './SelfEmployed';
import { FormDropdown } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDropdown';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';

export const Employment: React.FC = () => {
    const { t } = useTranslation();
    const { control, watch } = useFormContext<ApplicantCreation>();

    const beschaeftigungsart = watch('beschaeftigung.beschaeftigungsart');

    const employmentTypeOptions = Object.values(EMPLOYMENT_TYPES).map((value) => ({
        label: t(`EMPLOYMENT_TYPE.${value}`),
        value,
    }));

    const taxClassOptions = Object.values(TAX_CLASSIFICATIONS).map((value) => ({
        label: t(`TAX_CLASSIFICATION.${value}`),
        value,
    }));

    const renderOccupationForm = () => {
        switch (beschaeftigungsart) {
            case EMPLOYMENT_TYPES.ANGESTELLTER:
            case EMPLOYMENT_TYPES.ARBEITER:
                return <EmployeeWorker />;
            case EMPLOYMENT_TYPES.BEAMTER:
                return <Official />;
            case EMPLOYMENT_TYPES.AZUBI:
                return <Azubi />;
            case EMPLOYMENT_TYPES.FREIBERUFLER:
            case EMPLOYMENT_TYPES.SELBSTSTAENDIGER:
                return <SelfEmployed />;
            case EMPLOYMENT_TYPES.RENTNER:
                return <Pensioner />;
            case EMPLOYMENT_TYPES.STUDENT:
            case EMPLOYMENT_TYPES.ARBEITSLOSER:
            case EMPLOYMENT_TYPES.HAUSFRAU:
                return <OtherIncomeOnly />;
            default:
                return null;
        }
    };

    return (
        <div className="flex w-full flex-col gap-2">
            <FormCard>
                    <FormDropdown
                        id="beschaeftigung.steuerklasse"
                        label={t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.TAX_CLASSIFICATIONS')}
                        options={taxClassOptions}
                        control={control}
                    />

                    <FormDropdown
                        id="beschaeftigung.beschaeftigungsart"
                        label={t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.EMPLOYMENT_RELATIONSHIP')}
                        options={employmentTypeOptions}
                        control={control}
                    />
                    {renderOccupationForm()}
            </FormCard>
        </div>
    );
};
